const productCardInteractiveSelector = [
  'a',
  'button',
  'input',
  'select',
  'textarea',
  'label',
  '[role="button"]',
  '.js-product-colour-variants',
].join(', ')

function openProductCardFromPassiveArea(event) {
  if (event.defaultPrevented || event.button !== 0) return

  const card = event.target.closest('.inner-product')
  if (!card || event.target.closest(productCardInteractiveSelector)) return
  if (window.getSelection && window.getSelection().toString()) return

  const link = card.querySelector('.productEntityClick[href]')
  if (!link) return

  if (event.metaKey || event.ctrlKey || event.shiftKey) {
    window.open(link.href, '_blank', 'noopener')
    return
  }

  link.click()
}

document.addEventListener('click', openProductCardFromPassiveArea)
